var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center color-blue my-2"},[_c('font-awesome-icon',{attrs:{"icon":"spinner","pulse":""}}),_c('strong',[_vm._v(" Chargement en cours ...")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }